import React, { useEffect } from "react";

import Parallax from "components/MaterialKit/Parallax/Parallax";
import styles from "assets/jss/material-kit-react/views/homeStyle.js";
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "components/MaterialKit/Grid/GridContainer";
import GridItem from "components/MaterialKit/Grid/GridItem";
import Button from "../../components/MaterialKit/CustomButtons/Button";
import AboutSection from "./AboutSection";
import TeamSection from "./TeamSection";

import { useHistory } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { DASHBOARD } from "constants/routes";

const useStyles = makeStyles(styles);

const Home = (props) => {
  const classes = useStyles();
  const history = useHistory();

  const { isAuthenticated } = useSelector((state) => {
    return {
      isAuthenticated: state.auth.isAuthenticated,
      loading: state.auth.loading,
    };
  }, shallowEqual);

  useEffect(() => {
    if (isAuthenticated) {
      history.push(DASHBOARD);
    }
  }, [isAuthenticated, history]);
  return (
    <div>
      <Parallax filter image={require("assets/img/main/gaming.gif")}>
        <div className={classes.container}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={6}>
              <h1 className={classes.title}>Gamers World</h1>
              <h4>
                Your one stop destination to be a pro gamer and connect with the
                world.
              </h4>
              <br />
              <Button color="success" size="lg" round>
                <i className="fas fa-gamepad"></i>
                Get Started
              </Button>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <AboutSection />
          <TeamSection />
        </div>
      </div>
    </div>
  );
};

Home.propTypes = {};

export default Home;
